import React from 'react';
import { C, LAYOUT } from '../../shared/design-tokens.js';
import { CONTROL_INPUT, MUTED_LABEL } from './scheduler-ui.js';

interface SchedulerSearchBarProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export default function SchedulerSearchBar({ search, onSearchChange }: SchedulerSearchBarProps) {
  return (
    <div style={LAYOUT.subPanel}>
      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'minmax(220px, 360px)' }}>
        <div>
          <label style={MUTED_LABEL}>Scheduler search</label>
          <input
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder="Search drivers in scheduler..."
            style={CONTROL_INPUT}
          />
        </div>
      </div>
      <div style={{ color: C.textMuted, fontSize: 11, marginTop: 8 }}>Filters assignment and grid read surfaces only.</div>
    </div>
  );
}
